import { pipe } from '../../Function/dist/effect-Function.esm.js';
import { liveServices } from '../../internal/defaultServices.esm.js';
import { merge, provideMerge, syncContext } from '../../internal/layer.esm.js';
import { defaultTestClock } from '../../TestClock/dist/effect-TestClock.esm.js';
import { testConfigLayer, liveLayer, annotationsLayer, sizedLayer } from '../../TestServices/dist/effect-TestServices.esm.js';

/**
 * @since 2.0.0
 */

/** @internal */
const live = /*#__PURE__*/pipe( /*#__PURE__*/annotationsLayer(), /*#__PURE__*/merge( /*#__PURE__*/liveLayer()), /*#__PURE__*/merge( /*#__PURE__*/sizedLayer(100)), /*#__PURE__*/merge( /*#__PURE__*/pipe( /*#__PURE__*/liveLayer(), /*#__PURE__*/merge( /*#__PURE__*/annotationsLayer()), /*#__PURE__*/provideMerge(defaultTestClock))), /*#__PURE__*/merge( /*#__PURE__*/testConfigLayer({
  repeats: 100,
  retries: 100,
  samples: 200,
  shrinks: 1000
})));

/**
 * @since 2.0.0
 */
const LiveContext = /*#__PURE__*/syncContext(() => liveServices);

/**
 * @since 2.0.0
 */
const TestContext = /*#__PURE__*/provideMerge(LiveContext, live);

export { LiveContext, TestContext, live };
